import { defineComponent } from "vue";
import { Key } from "../../../../../types/skyward/svg";
import { browseStore } from "../../store";
import { VueBrowseClasses } from "./../../classes";
import { Classes, getButton, isSmallScreen } from "./common";
import { JobPosting, JobPostingStore } from "./types";

export default defineComponent(
    {
        name: "dataHeader",
        setup()
        {
            if (isSmallScreen())
            {
                return () => null;
            }

            const state = browseStore.injectBrowseState<JobPostingStore, JobPosting>();
            if (!state)
            {
                window.skyward.error.reportException(new ReferenceError("Unable to retrieve browse state"));
                return () => null;
            }
            let dataSource = state.features.dataSource;

            const nonSortableColumns: (keyof JobPosting | "")[] = ["", "PayDisplayString"];
            function getRowData()
            {
                const sorts: { [key: string]: boolean } = dataSource.sorts;
                return state.displayColumns.map(column =>
                {
                    const sortDown: boolean = sorts[column.fieldName.uncapitalize()];
                    const svgName: Key = sortDown == undefined ? "Reorder" : sortDown ? "ArrowDown" : "ArrowUp";

                    const sortClickCallback = () =>
                    {
                        const columnName: string = column.fieldName.uncapitalize();
                        const currentlySorted: boolean = sorts[columnName] == true;
                        const newSorts: { [key: string]: boolean } = {};
                        newSorts[columnName] = !currentlySorted;
                        dataSource.sorts = newSorts;
                    };

                    const columnWidth: string = "auto";
                    return (
                        <th class={VueBrowseClasses.HeaderCell} style={{ width: columnWidth }}>
                            <div class={Classes.JobPostingColumnDiv}>
                                <div>{getButton("", svgName, sortClickCallback, { visible: !nonSortableColumns.includes(column.fieldName as (keyof JobPosting | "")) })}</div>
                                <span class={[VueBrowseClasses.HeaderCellContent, Classes.JobPostingColumnSpan]}>{column.displayName}</span>
                            </div>
                        </th>
                    );
                })
            }

            return () => (
                <thead class={VueBrowseClasses.THead}>
                    <tr class={VueBrowseClasses.HeaderRow}>{getRowData()}</tr>
                </thead>
            );
        }
    });
